import { useMemo } from "react";
import type { GoalDetail } from "web_myplann/Goals/Types/GoalDetail";
import type { CurrencyEnum } from "web_myplann/Infrastructure/Api/Api";

export type RentPlan = {
	isPerpetual: boolean;
	currentYear: number;
	accumYears: number;
	drawYears: number;
	endYear: number | null;
	accumFlex: number;
	drawFlex: number;
	monthlyRent: number;
	savingsTarget: number;
	dueYear: number;
	currencyCode?: CurrencyEnum;
};

export const useRentPlan = (goal: GoalDetail): RentPlan | null => {
	return useMemo(() => {
		if (goal.completed || !goal.rentMode || goal.monthlyRent <= 0) return null;

		const currentYear = new Date().getFullYear();
		const accumYears = Math.max(1, goal.dueYear - currentYear);
		const isPerpetual = goal.rentYears <= 0;
		const drawYears = isPerpetual ? 0 : goal.rentYears;

		return {
			isPerpetual,
			currentYear,
			accumYears,
			drawYears,
			endYear: isPerpetual ? null : goal.dueYear + drawYears,
			accumFlex: Math.max(1, accumYears),
			drawFlex: isPerpetual ? Math.max(2, accumYears) : Math.max(1, drawYears),
			monthlyRent: goal.monthlyRent,
			savingsTarget: goal.savingsTarget,
			dueYear: goal.dueYear,
			currencyCode: goal.currencyCode,
		};
	}, [goal]);
};
